import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FlowChart,
  title: 'Flow Chart',
  category: ComponentCategory.FormControls,
};
